import { Link, useLocation } from "react-router-dom";

const ExpungeSidebar = () => {
    const location = useLocation();

    // Navigation Item Component
    const NavItem = ({ to, label }) => {
        const isActive = location.pathname === to;

        return (
            <Link
                to={to}
                className={`pl-3 py-2 d-flex align-items-center border-start border-3 transition-all ${isActive ? 'case-management-sidebar' : ''} cursor-pointer text-decoration-none`}
                onMouseEnter={(e) => {
                    if (!isActive) {
                        e.currentTarget.classList.add('case-management-sidebar-hover');
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isActive) {
                        e.currentTarget.classList.remove('case-management-sidebar-hover');
                    }
                }}
                style={{ fontSize: '14px', gap: "6px" }}
            >
                <span
                    className="text-nowrap"
                    style={{
                        fontWeight: isActive ? '600' : '500',
                        color: isActive ? 'white' : 'inherit',
                    }}
                >
                    {label}
                </span>
            </Link>
        );
    };

    return (
        <>
            <div className="w-100">
                <div>
                    <div className="mb-2">
                        <div>
                            <NavItem to="/Expunge" label="Expunge" />
                            <NavItem to="/UnExpunge" label="Unexpunge" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpungeSidebar